@defer (when !isLoading()) {
  @if (privateRecipientDetails?.length > 0 || companies?.length > 0) {
    <div class="tables-wrapper">
      <!-- PHONE NUMBERS -->
      @if (phoneRecipientsDetails?.length > 0) {
        <bi-address-info-table
          [recipientsDetails]="phoneRecipientsDetails"
          contactDetailIconClass="fa-solid fa-mobile-alt"
          [isStatus]="dialogInputData.isStatus"
          [useColumnWidthLimits]="alignTables()"
          recipientType="phone"
          @fadeIn
        />
      }

      <!-- EMAILS -->
      @if (emailRecipientsDetails?.length > 0) {
        <bi-address-info-table
          [recipientsDetails]="emailRecipientsDetails"
          contactDetailIconClass="fa-regular fa-envelope"
          [isStatus]="dialogInputData.isStatus"
          [useColumnWidthLimits]="alignTables()"
          recipientType="email"
          @fadeIn
        />
      }

      <!-- E-BOKS -->
      @if (eboksRecipientsDetails?.length > 0) {
        <bi-address-info-table [recipientsDetails]="eboksRecipientsDetails" [isStatus]="dialogInputData.isStatus" recipientType="eboks" [useColumnWidthLimits]="alignTables()" @fadeIn />
      }

      <!-- COMPANIES -->
      @if (companies?.length > 0) {
        <bi-address-info-table [recipientsDetails]="companies" recipientType="company" [useColumnWidthLimits]="alignTables()" @fadeIn />
      }
    </div>
  } @else {
    <!-- No info -->
    <p class="text-center" translate>shared.NoInfoFound</p>
  }

  @if (dialogInputData.enableDeselection != undefined ? dialogInputData.enableDeselection : true) {
    <div class="text-center mt-4" @fadeIn>
      <!-- Deselect button and OK/cancel -->
      @if (!showAreYouSureToDeselect()) {
        <p-button type="button" severity="info" [label]="'messages.DeselectAddress' | translate" (click)="showAreYouSureToDeselect.set(true)" />
      } @else {
        <div @fadeIn>
          <h4 class="text-center" translate>messages.ShouldAddressBeDeselected</h4>
          <div class="flex justify-content-center w-full gap-2 bi-p-fluid">
            <!-- Delete -->
            <p-button type="button" severity="info" class="w-6 sm:w-4" [label]="'shared.Yes' | translate" (click)="onDeleteAddressClicked()" />

            <!-- Cancel -->
            <p-button type="button" severity="secondary" class="w-6 sm:w-4" [label]="'shared.Cancel' | translate" (click)="showAreYouSureToDeselect.set(false)" />
          </div>
        </div>
      }
    </div>
  }
} @placeholder {
  <bi-spinner [centerInParent]="true" @fadeIn />
}
